export default function ArrowIcon() {
  return (
    <svg
      className='block transition stroke-current text-grayLColor hover:text-accentColor dark:text-secondaryColor dark:hover:text-accentColor active:scale-95'
      width='52'
      height='52'
      viewBox='0 0 52 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M23.3333 34L15.3333 26M15.3333 26L23.3333 18M15.3333 26L36.6667 26M50 26C50 12.7451 39.2549 2.00001 26 2C12.7452 2 2.00001 12.7451 2 26C2 39.2548 12.7452 50 26 50C39.2549 50 50 39.2548 50 26Z'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
